export const MOBILE_PAYMENT_SCREEN_NAME = "mobile_payment";

/**
 * Identity context attached to every mobile payment event. The interactive
 * session id (ISID) is the play session the phone is interacting with — shared
 * across all payers at the table; the checkout id identifies this payer's
 * individual payment attempt within it. The server also stamps
 * interactive_session_id at ingestion; the client sends it for completeness.
 */
export interface PaymentEventContext {
  interactiveSessionId: string;
  checkoutId: string | null;
  paidSessionIdFromUrl: string | null;
}

function identityProperties(ctx: PaymentEventContext): Record<string, unknown> {
  return {
    screen_name: MOBILE_PAYMENT_SCREEN_NAME,
    interactive_session_id: ctx.interactiveSessionId,
    ...(ctx.checkoutId ? { checkout_id: ctx.checkoutId } : {}),
    ...(ctx.paidSessionIdFromUrl ? { paid_session_id: ctx.paidSessionIdFromUrl } : {}),
  };
}

export function paymentInteractionProperties(
  ctx: PaymentEventContext,
  interactionType: string,
  extra: Record<string, unknown> = {},
): Record<string, unknown> {
  return {
    ...identityProperties(ctx),
    interaction_type: interactionType,
    ...extra,
  };
}

export function paymentOutcomeProperties(
  ctx: PaymentEventContext,
  extra: Record<string, unknown> = {},
): Record<string, unknown> {
  return {
    ...identityProperties(ctx),
    ...extra,
  };
}

export function readPaidSessionIdFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  const value = new URLSearchParams(window.location.search).get("paid_session_id");
  return value && value.length > 0 ? value : null;
}
